import { render, staticRenderFns } from "./ResetDetail.vue?vue&type=template&id=5f583c0a&scoped=true&"
import script from "./ResetDetail.vue?vue&type=script&lang=js&"
export * from "./ResetDetail.vue?vue&type=script&lang=js&"
import style0 from "./ResetDetail.vue?vue&type=style&index=0&id=5f583c0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f583c0a",
  null
  
)

export default component.exports